import { render, staticRenderFns } from "./UrgencyConfig.vue?vue&type=template&id=cb9b3052&scoped=true&lang=pug"
import script from "./UrgencyConfig.vue?vue&type=script&lang=js"
export * from "./UrgencyConfig.vue?vue&type=script&lang=js"
import style0 from "./UrgencyConfig.vue?vue&type=style&index=0&id=cb9b3052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9b3052",
  null
  
)

export default component.exports